import { Chess } from "chess.js";

import type { LivestreamSnapshot } from "./types";

function replayLivestreamUciMove(board: Chess, uci: string) {
  const from = uci.slice(0, 2);
  const to = uci.slice(2, 4);
  const promotion = uci.slice(4, 5) || undefined;
  return board.move({ from, to, promotion });
}

export function buildLivestreamDisplayBoard(snapshot: LivestreamSnapshot, displayPly: number) {
  const board = snapshot.initial_fen ? new Chess(snapshot.initial_fen) : new Chess();
  const replayCount = Math.max(0, Math.min(displayPly, snapshot.visible_moves.length));
  for (const move of snapshot.visible_moves.slice(0, replayCount)) {
    replayLivestreamUciMove(board, move);
  }
  return board;
}

export function resolveLivestreamDisplayFen(snapshot: LivestreamSnapshot, displayPly: number) {
  return buildLivestreamDisplayBoard(snapshot, displayPly).fen();
}

export function buildLichessAnalysisUrl(fen: string) {
  const lichessFen = fen.trim().replace(/\s+/g, "_");
  return `https://lichess.org/analysis/standard/${encodeURI(lichessFen)}`;
}
